module.exports = __webpack_public_path__ + "static/media/IconOneTimeCode.231bfc9d.svg";